import { render } from "./RecommendCourseListContents.vue?vue&type=template&id=a1dc200c&ts=true"
import script from "./RecommendCourseListContents.vue?vue&type=script&lang=ts"
export * from "./RecommendCourseListContents.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__